module.exports = __webpack_public_path__ + "img/5.06b2e24d.png";